import { useEffect } from 'react';

function useLockScroll() {
  useEffect(() => {
    document.body.classList.add('overflow-y-hidden');

    return () => {
      document.body.classList.remove('overflow-y-hidden');
    };
  }, []);
  return false;
}

export default useLockScroll;
